module.exports = __webpack_public_path__ + "static/img/case_banner_02.dcabb0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_02.png
// module id = 5yJe
// module chunks = 34